export default "__VITE_ASSET__DR2qFvvp__"